import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setRecipient,
  setAmount,
  setRemark,
  setSaveAsBeneficiary,
  confirmTransfer,
  verifyPassword,
  verifyOTP,
  setPassword,
  setOtp,
} from "../redux/slices/walletTransferSlice";
import { RootState } from "../redux/store";
import { useState } from "react";
import { toast } from "sonner"; // Import toast

const useWalletTransfer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isPassword, setIsPassword] = useState(false);

  // Redux state
  const {
    recipient,
    amount,
    remark,
    saveAsBeneficiary,
    transferStatus,
    password,
    otp,
  } = useSelector((state: RootState) => state.walletTransfer);
  const transfer_fee = 5;
  // Local state for controlling steps

  // Form handling functions
  const handleRecipientChange = (value: string) => {
    dispatch(setRecipient(value));
  };
/**
 * 
 * 
 * handleOTPChange,
    otp,
    handleOTPSubmit,
 */
  const handleAmountChange = (value: string) => {
    dispatch(setAmount(value));
  };

  const handlePassswordChange = (value: string) => {
    dispatch(setPassword(value));
  };

  const handleRemarkChange = (value: string) => {
    dispatch(setRemark(value));
  };

  const handleOTPChange = (value: string) => {
    dispatch(setOtp(value));
  };

  const toggleSaveAsBeneficiary = () => {
    dispatch(setSaveAsBeneficiary(!saveAsBeneficiary));
  };
  const handleModalConfirm = () => {
    if (!recipient || !amount) {
      toast.warning("Please provide recipient and amount!");
      return;
    }
    setShowModal(false);

    handleConfirmTransfer();
  };

  const toggleConfirmModal = () => {
    setShowModal(!showModal); // Close the modal
  };

  // Function to clear data
  const resetTransferData = () => {
    dispatch(setRecipient(""));
    dispatch(setAmount(""));
    dispatch(setRemark(""));
    dispatch(setSaveAsBeneficiary(false));
    dispatch(setPassword(""));
    dispatch(setOtp(""));
  };

  // Action: Confirm Transfer Details
  const handleConfirmTransfer = () => {
    if (!recipient || !amount) {
      toast.error("Please provide recipient and amount!");
      return;
    }

    dispatch(confirmTransfer({ recipient, amount, remark, saveAsBeneficiary }));
    toast.success("Transfer details confirmed!");
    navigate("provide-password");
  };

  // Action: Verify Password
  const handlePasswordSubmit = () => {
    if (!password) {
      toast.error("Password cannot be empty!");
      return;
    }

    dispatch(verifyPassword(password));
    if (transferStatus === "password-verified") {
      toast.success("Password verified!");
      navigate("provide-otp");
    } else {
      toast.error("Password mismatch! Please try again.");
    }
  };

  // Action: Verify OTP
  const handleOTPSubmit = () => {
    if (!otp) {
      toast.error("OTP cannot be empty!");
      return;
    }

    dispatch(verifyOTP(otp));
    if (transferStatus === "otp-verified") {
      toast.success("Transfer successful!");
      resetTransferData(); // Clean data after success
      navigate("/wallet/transfer"); // Redirect after success
    } else {
      toast.error("OTP mismatch! Please try again.");
    }
  };

  return {
    recipient,
    amount,
    remark,
    saveAsBeneficiary,
    otp,
    password,
    transfer_fee,
    showModal,
    isPassword,
    setIsPassword,
    handleModalConfirm,
    toggleConfirmModal,
    handleOTPChange,
    handlePassswordChange,
    handleRecipientChange,
    handleAmountChange,
    handleRemarkChange,
    toggleSaveAsBeneficiary,
    handleConfirmTransfer,
    handlePasswordSubmit,
    handleOTPSubmit,
    navigate,
  };
};

export { useWalletTransfer };
